import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./ModalSoundCard.module.scss";
import { AiOutlineClose } from "react-icons/ai";
import { encodedB64 } from "../../../CustomHooks/DecodedBase64";
import Axios from "../../../_services/caller.service";
import Loader from "../../UiComponents/loader/Loader";
import Success from "../../UiComponents/sucess/Success";

const ModalSoundCard = ({
  transductorNameForUpdate,
  setDisplayModalConfirm,
  updateSoundCard,
  cabId,
  cabname,
  setMaj,
  maj,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [sucess, setSuccess] = useState(false);
  // ICI on remplace transductor par transductorNameForUpdate
  const registerNewCardSound = async (transductor) => {
    const soundCardSorted = await sortGoodTypeTransductor(transductor);
    //setLoading(true);
    const soundCardNameB64 = encodedB64(soundCardSorted);

    if (soundCardNameB64 === "") {
      // if No changement we do nothing
      setLoading(false);
      setSuccess(true);
      setMaj(!maj);
      setTimeout(() => {
        setSuccess(false);
      }, 1500);
      return;
    }
    //create catid if they not exist
    Axios.post(`/createCatid/${cabId}`, {})

      .then((response) => {
        Axios.put(`/updateSoundCardName/${cabId}`, {
          data: { transductor: transductor, soundCardName: soundCardNameB64 },
        })

          .then((response) => {
            setLoading(false);
            setSuccess(true);
            setMaj(!maj);
            setTimeout(() => {
              setDisplayModalConfirm(false);
              setSuccess(false);
            }, 1500);
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const sortGoodTypeTransductor = (transductor) => {
    switch (transductor) {
      case "CO":
        return updateSoundCard.CO;

      case "Casque":
        return updateSoundCard.Casque;

      case "Inserts":
        return updateSoundCard.Inserts;

      case "HSSoundcardUse":
        return updateSoundCard.HSSoundcardUse;

      case "DiracSoundcardUse":
        return updateSoundCard.DiracSoundcardUse;

      case "Operator":
        return updateSoundCard.Operator;

      default:
        return "";
    }
  };

  return (
    <>
      <div
        onClick={() => setDisplayModalConfirm(false)}
        className={styles.wrapperModal}
      ></div>
      <div className={styles.containerModal}>
        <h4 className={styles.modalTitle}>Mise à jour carte son</h4>
        <button
          className={styles.closeBtn}
          onClick={() => setDisplayModalConfirm(false)}
        >
          <AiOutlineClose />
        </button>

        <div className={styles.containerInfos}>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Cabine :</span>
            <span className={styles.infoValue}>{cabname}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Sortie :</span>
            <span className={styles.infoValue}>{transductorNameForUpdate}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Carte :</span>
            <span className={styles.infoValue}>
              {sortGoodTypeTransductor(transductorNameForUpdate)}
            </span>
          </div>
        </div>

        <div className={styles.containerReponse}>
          {loading && <Loader />}
          {sucess && <Success success={t("superadmin_ui.soundcard_updated")} />}
        </div>

        <div className={styles.containerBtn}>
          <button
            className={styles.btnCancel}
            onClick={() => setDisplayModalConfirm(false)}
          >
            {t("common.cancel")}
          </button>
          <button
            className={styles.btnConfirm}
            onClick={() => registerNewCardSound(transductorNameForUpdate)}
          >
            {t("common.confirm")}
          </button>
        </div>
      </div>
    </>
  );
};

export default ModalSoundCard;
